<template>
  <div>

    <h3>软件使用说明</h3>
    <el-divider></el-divider>
    <h4>一、同步订单</h4>
    <el-image :src="showset" style="width: 90%"></el-image>
    <p>1、选择要显示的订单属性，点【保存显示顺序】，你点击的先后顺序就是显示的顺序，在页面下端会看到实时的显示顺序。</p>
    <p>2、此项只需设置一次，保存后不需重复设置。</p>
    <el-image :src="startdate" style="width: 90%"></el-image>
    <p>1、选择订单所属的时间段，订单状态，同步订单时会按所选参数同步订单数据。</p>
    <p>2、选择按付款时间同步时，只能同步付款时间和拍下时间间隔在3天以内的订单，超过3天的，请使用拍下时间。</p>
    <el-image :src="tongbu" style=""></el-image>
    <p>1、点【同步订单】，开始从淘宝同步订单数据，如果提示数据超限，请缩短订单的时间范围，一次同步的订单数量（含子订单）控制在10000以内。</p>
    <p>2、如果需要查看买家留言和卖家备注，请点同步备注，此操作耗时长，请耐心等待</p>
    <p>3、同步过程时，会提示"数据同步中"，完成后会提示"数据同步完成"，完成后【查看数据】。</p>
    <el-divider></el-divider>
    <h4>二、显示数据</h4>
    <el-image :src="showdata" style="width: 90%"></el-image>
    <p>1、为保护买家隐私，买家信息全部掩码脱敏显示，需要查看时请点击【批量明文】查看。</p>
    <p>2、选择按订单号合并，同一订单的相关属性只显示一行，商品明细仍分行显示。</p>
    <p>3、可以选择订单号，时间，只查看部分订单数据。</p>
    <p>4、订单数据默认按拍时下时间排序，最近拍下的订单显示在最上面。</p>
    <el-divider></el-divider>
    <h4 id="fh">三、批量发货</h4>
    <el-image :src="fahuo" style="width: 90%"></el-image>
    <p>1、【导入订单】，需要导入订单号，运单号，物流公司，一次200单。子订单号可不填写</p>
    <p>2、选择发货方式，点批量发货，常用方式为自已联系，虚拟发货只需要导入订单号，选虚拟发货。</p>
    <p>3、拆单发货，如果一个订单号有2件以上商品，其中一件已发货，发剩余订单时，需要填写子订单号才可以发货</p>
    <p style="font-weight: bold">4、系统自动统计发货失败的单量，成功率低的用户会限制发货数量。</p>
    <p>5、发货格式为如下格式，在Excel表格中选中内容，点复制，再粘贴到批量发货的页面上。</p>
    <el-image :src="excel1" style="width: 50%"></el-image>
    <el-image :src="imp" style="width: 50%"></el-image>
    <el-divider></el-divider>
    <h4 id="memo">四、批量备注</h4>
    <el-image :src="beizhu" style="width: 90%"></el-image>
    <p>1、【导入订单】，需要导入订单号，备注旗帜，备注内容, 一次200单。</p>
    <p>2、备注旗帜为数字， 0：灰色；1：红；2：黄；3：绿；4：蓝；5：紫；-1：不更改旗帜颜色。</p>
    <p style="font-weight: bold">3、系统自动统计备注失败的单量，成功率低的用户会限制备注数量。</p>
    <p>4、备注格式为如下格式，在Excel表格中选中内容，点复制，再粘贴到批量备注的页面上。</p>
    <el-image :src="excel2" style="width: 40%"></el-image><br>
    <el-image :src="imp2" style="width: 50%"></el-image>
    <el-divider></el-divider>
    <h4 >五、批量延长发货时间</h4>
    <el-image :src="yanshi" style="width: 90%"></el-image>
    <p>1、【导入订单】，需要导入订单号，延长天数, 一次200单。</p>
    <p>2、天数只能3，7，10， 其他数字无效。</p>
    <p style="font-weight: bold">3、系统自动统计失败的单量，成功率低的用户会限制订单数量。</p>
    <p>4、延长格式为如下格式，在Excel表格中选中内容，点复制，再粘贴到批量延长时间的页面上。</p>
    <el-image :src="excel3" style="width: 40%"></el-image><br>
    <el-image :src="imp3" style="width: 50%"></el-image>
    <el-divider></el-divider>
    <h4 id="zzh">六、子账号授权</h4>
    <p>1、进入千牛卖家中心，【店铺】-<el-link style="color: #000000" target="_blank" href="https://myseller.taobao.com/home.htm/Subaccount/" >【子帐号管理】</el-link></p>
    <el-image :src="zzhgl" style="width: 20%"></el-image>
    <p>2、打开后，点击【应用管理】，找到【订单助手】</p>
    <el-image :src="yygl" style="width: 60%"></el-image>
    <p>3、找到需要授权的子号，点右方的【授权】,确认授权即可</p>
    <el-image :src="shouquan" style="width: 60%"></el-image>
    <el-divider></el-divider>
    <p>此处为文档底部，没有更多内容了</p>
  </div>
</template>

<script>
    export default {
        name: "Help",
      data(){
          return{
            showset:'./static/image/shunxu.png',
            startdate:'./static/image/startdate.png',
            tongbu:'./static/image/tongbu.png',
            showdata:'./static/image/showdata.png',
            fahuo:'./static/image/fahuo.png',
            excel1:'./static/image/excel1.png',
            imp:'./static/image/import.png',
            beizhu:'./static/image/beizhu.png',
            excel2:'./static/image/excel2.png',
            imp2:'./static/image/import2.png',
            yanshi:'./static/image/yanshi.png',
            excel3:'./static/image/excel3.png',
            imp3:'./static/image/import3.png',
            zzhgl:'./static/image/zzhgl.jpg',
            yygl:'./static/image/yygl.jpg',
            shouquan:'./static/image/shouquan.jpg',

          }
      },
      methods:{
        goto:function () {
          document.querySelector("#zzh").scrollIntoView();
        }
      },
      mounted() {
        //console.log(this.$route.params);
        //if (this.$route.params != null) {
          let id = this.$route.params.id;
          console.log(id);
          if (id != undefined) {
            //document.querySelector("#plfh").scrollIntoView(true);
            let inter = setInterval(() => {
              let target = document.querySelector('#'+id);
              if (target) {
                clearInterval(inter);
                target.scrollIntoView();
              }
            }, 100)
          }
        }
      //}
    }

//?top_appkey=12493118&top_parameters=ZXhwaXJlc19pbj0yNjE4MzgyJmlmcmFtZT0xJnIxX2V4cGlyZXNfaW49MjYxODM4MiZyMl9leHBpcmVzX2luPTI1OTIwMCZyZV9leHBpcmVzX2luPTI2MTgzODImcmVmcmVzaF90b2tlbj02MTAwNDI3MTlkMDQ2ZDFjODdiYjNjOGUxYjVmYmVjOTljMDExY2NkNmRiNjkxZjczODA5ODk2OSZ0cz0xNjA3MDkyODE3MzY5JnZpc2l0b3JfaWQ9NzM4MDk4OTY5JnZpc2l0b3Jfbmljaz13Z2FvZmEmdzFfZXhwaXJlc19pbj0yNjE4MzgyJncyX2V4cGlyZXNfaW49MTgwMA%3D%3D&top_session=61016276037d66faac9edd3e0d53adcdae119a067bf049e738098969&top_sign=Tu2mG%2Bw5kH3cSKMQaujnTA%3D%3D

</script>

<style scoped>
  .el-link.el-link--default {

    text-decoration:none;
  }

</style>



// WEBPACK FOOTER //
// src/page/Help.vue